// Gestionnaire global de wishlist
class GlobalWishlistManager {
  constructor() {
    this.wishlistKey = 'jennah_wishlist';
    this.wishlist = this.loadWishlist();
    this.init();
  }
  
  loadWishlist() {
    try {
      const stored = localStorage.getItem(this.wishlistKey);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.error('Erreur lors du chargement de la wishlist:', e);
      return [];
    }
  }
  
  saveWishlist() {
    try {
      localStorage.setItem(this.wishlistKey, JSON.stringify(this.wishlist));
      this.updateHeaderCounter();
    } catch (e) {
      console.error('Erreur lors de la sauvegarde de la wishlist:', e);
    }
  }
  
  addToWishlist(product) {
    if (!this.isInWishlist(product.id)) {
      this.wishlist.push(product);
      this.saveWishlist();
      return true;
    }
    return false;
  }
  
  removeFromWishlist(productId) {
    this.wishlist = this.wishlist.filter(p => p.id !== productId);
    this.saveWishlist();
  }
  
  isInWishlist(productId) {
    return this.wishlist.some(p => p.id === productId);
  }
  
  getWishlist() {
    return this.wishlist;
  }
  
  updateHeaderCounter() {
    const counter = document.querySelector('.wishlist-counter');
    if (counter) {
      counter.textContent = this.wishlist.length;
      counter.style.display = this.wishlist.length > 0 ? 'flex' : 'none';
      console.log('Compteur wishlist mis à jour:', this.wishlist.length);
    }
  }
  
  init() {
    this.updateHeaderCounter();
    
    // Initialiser tous les boutons wishlist sur la page
    this.initWishlistButtons();
    
    // Écouter les changements de page (pour les SPA)
    document.addEventListener('DOMContentLoaded', () => {
      this.updateHeaderCounter();
      this.initWishlistButtons();
    });
  }
  
  initWishlistButtons() {
    // Initialiser tous les boutons wishlist sur la page
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      this.initWishlistButton(btn);
    });
  }
  
  initWishlistButton(btn) {
    const productId = btn.dataset.productId;
    if (!productId) return;
    
    // Vérifier si le produit est déjà dans la wishlist
    if (this.isInWishlist(productId)) {
      btn.classList.add('is-active');
    }
    
    // Ajouter l'événement de clic
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const product = {
        id: productId,
        title: btn.dataset.productTitle,
        url: btn.dataset.productUrl,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        available: btn.dataset.productAvailable === 'true'
      };
      
      if (this.isInWishlist(productId)) {
        // Retirer de la wishlist
        console.log('Retrait de la wishlist:', productId);
        this.removeFromWishlist(productId);
        btn.classList.remove('is-active');
        
        // Animation de suppression
        btn.classList.add('wishlist-btn--adding');
        setTimeout(() => btn.classList.remove('wishlist-btn--adding'), 600);
      } else {
        // Ajouter à la wishlist
        console.log('Ajout à la wishlist:', productId, product);
        this.addToWishlist(product);
        btn.classList.add('is-active');
        
        // Animation d'ajout
        btn.classList.add('wishlist-btn--adding');
        setTimeout(() => btn.classList.remove('wishlist-btn--adding'), 600);
      }
    });
  }
}

// Initialiser le gestionnaire global
document.addEventListener('DOMContentLoaded', () => {
  window.wishlistManager = new GlobalWishlistManager();
});

